import * as React from 'react';
import { PhoneButtonStickyLayout } from './components/PhoneButtonStickyLayout';
import { PhoneDetailsPopup } from './components/PhoneDetailsPopup';
import { ShowPhoneButton } from './components/ShowPhoneButton';

export interface IPhoneButtonTabletProps {
  builderLogoUrl?: string;
  builderName?: string;
  onPhoneClick?(): void;
  onPhoneShow?(): void;
  phone: string;
}

export const PhoneButtonTablet: React.FC<IPhoneButtonTabletProps> = ({
  builderLogoUrl,
  builderName,
  phone,
  onPhoneClick,
  onPhoneShow,
}) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const handleShowPhone = React.useCallback(() => {
    setIsVisible(true);

    if (onPhoneShow) {
      onPhoneShow();
    }
  }, [onPhoneShow]);

  const handleClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);

  return (
    <>
      <PhoneButtonStickyLayout>
        <ShowPhoneButton onClick={handleShowPhone} />
      </PhoneButtonStickyLayout>
      <PhoneDetailsPopup
        open={isVisible}
        onClose={handleClose}
        onPhoneClick={onPhoneClick}
        builderLogoUrl={builderLogoUrl}
        builderName={builderName}
        phone={phone}
      />
    </>
  );
};
